/* eslint-disable react-hooks/exhaustive-deps */
import { QrcodeOutlined, SaveOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, Steps } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import InputTag from '../../../components/InputTag';
import LocationSearchLocationIQ from '../../../components/LocationSearchLocationIQ';
import regex from '../../../constants/system.keys';
import { addExternalDeviceReturn, checkExternalDeviceReturn, } from '../../../redux/actions';
import RTMPImage from '../../../assets/images/RTMP_ADD2.png';

const { Step } = Steps;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const RTMPlinkAddCamera = ( {
  typeCamera = 'rtmp_camera',
  dispatch,
  onCheckExternalDevice,
  onAddCamera,
  checkDeviceReturn,
  activeDeviceReturn,
  onUpdate,
  handleAddSuccessful,
  onClose,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [requestId, setRequestId] = useState(new Date().getTime());
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [serialInput, setSerialInput] = useState('');
  const [deviceSerial, setDeviceSerial] = useState('');
  const [nameInput, setNameInput] = useState('');
  const [isBlock, setIsBlock] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [address, setAddress] = useState({
    note: '',
  });
  const [alertUpdate, setAlertUpdate] = useState({
    visible: false,
    type: null,
    message: null,
  });
  const { updateDevice, addExternalDevice } = useSelector((state) => state);
  const [updateReturn, setUpdateReturn] = useState();
  const serialRef = useRef(null);
  const [rtmpUrl, setRtmpUrl] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(()=> {
  }, [serialRef , deviceSerial])
  useEffect(() => {
    return () => {
      setIsLoading(false);
      setStep(0);
      setSerialInput('');
      setDeviceSerial('');
      setNameInput('');
      setRtmpUrl('');
      setIsBlock(false);
      setIsLoad(false);
      setAddress({ note: '' });
      setAlertUpdate({ visible: false, type: null, message: null });
      setUpdateReturn(null);
      form.resetFields();
    };
  }, [form]);
  

  useEffect(() => {
    setIsLoading(false);
    if (
      checkDeviceReturn &&
      (checkDeviceReturn.result === -2 || checkDeviceReturn.result === -3 || checkDeviceReturn.result === -8)
    ) {
      form.setFields([
        {
          name: 'serial',
          errors: [checkDeviceReturn.result === -8 ? 'Factory Serial has existed' : checkDeviceReturn.message],
        },
      ]);
    }
    if (checkDeviceReturn && checkDeviceReturn.result === 1) {
      if (
        checkDeviceReturn.data &&
        JSON.parse(checkDeviceReturn.data)?.serial
      ) {
        setDeviceSerial(JSON.parse(checkDeviceReturn.data)?.serial);
        dispatch(checkExternalDeviceReturn(null));
        form.resetFields();
        return setStep(1);
      } else {
        form.setFields([
          {
            name: 'serial',
            errors: ['Serial Invalid'],
          },
        ]);
      }
    }
  }, [activeDeviceReturn, checkDeviceReturn, dispatch, form, serialInput]);

  const onFinish = useCallback(
    (values) => {
      setIsLoading(true);
      if (step === 0) {
        console.log(1)
        setSerialInput(values.serial);
        return onCheckExternalDevice(values.serial);
      }
      if (step === 1) {
        console.log(2)
        setNameInput(values.name);
        return onAddCamera(serialInput, values.name, deviceSerial, typeCamera);
      }
    },
    [onAddCamera, onCheckExternalDevice, serialInput, step, deviceSerial]
  );

  /////////////////////////////////////////////////////////////

  useEffect(() => {
    if (updateDevice && updateDevice.requestId === requestId) {
      setUpdateReturn(updateDevice);
    }
  }, [updateDevice]);

  useEffect(() => {
    form.setFieldsValue({ serial: serialInput });
    return () => {
      setAlertUpdate({ visible: false });
      form.resetFields();
    };
  }, [form, serialInput]);

  useEffect(() => {
    if (serialRef.current && step === 0) {
      setTimeout(() => {
        serialRef.current.input.focus();
      }, 1);
    }
  }, [serialRef, step]);

  useEffect(() => {
    if (addExternalDevice) {
      setIsLoading(false);
      dispatch(addExternalDeviceReturn(null));
      form.setFieldsValue({
        nameDefault: nameInput,
        lastSerial: serialInput,
      });
      setRtmpUrl(addExternalDevice.rtmpUrl || '');
      setStep(2);
    }
  }, [addExternalDevice , checkDeviceReturn, dispatch, form, nameInput, serialInput]);

  const onChangeStep = (step) => {
    form.resetFields();
    setStep((state) => (state > step ? step : state));
  };

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
  };

  useEffect(() => {
    if (updateReturn && updateReturn.serial === deviceSerial) {
      setIsLoad(false);
      if (updateReturn.isSuccess) {
        setUpdateReturn(null);
        setStep(3);
        form.resetFields();
      } else {
        setAlertUpdate({
          visible: true,
          type: 'warning',
          message: t('Something went wrong, try again!!'),
        });
      }
    }
  }, [form, handleAddSuccessful, deviceSerial, t, updateReturn]);

  const handleOnUpdate = useCallback(
    (values) => {
      if (address && requestId) {
        const data = {
          name: values.nameDefault,
          note: values.location ?? '',
          serial: deviceSerial,
          lat: address.lat ?? 0,
          lng: address.lng ?? 0,
          tags: values.tags?.join(';')?.toLowerCase() || ';',
        };
        const dataTimeRequest = new Date().getTime();
        setRequestId(dataTimeRequest);
        setIsLoad(true);
        return onUpdate(data, dataTimeRequest);
      }
    },
    [address, onUpdate, requestId, deviceSerial]
  );

  useEffect(() => {
    if (step === 2) {
      form.setFieldsValue({
        rtmpUrl: rtmpUrl,
      });
    }
  }, [step, rtmpUrl, form]);

  if (step === 3) {
    return (
      <div className="edit-gateway-component">
        <div className="steps-add-gateways">
          <Steps
            size="small"
            current={step}
            onChange={onChangeStep}
            type="navigation"
            className="site-navigation-steps"
          >
            <Step title={t('Scan')} />
            <Step title={t('Create')} />
            <Step title={t('Update')} />
            <Step title={t('Configuration')} />
          </Steps>
        </div>
        <div style={{ marginTop: 24 }}>
          <Form layout="vertical">
            <Form.Item label={t('Tên camera')}>
              <Input value={nameInput} disabled />
            </Form.Item>
            <Form.Item label={t('RTMP Endpoint')}>
              <Input
                value={rtmpUrl}
                disabled
                suffix={
                  <Button
                    size="small"
                    onClick={() => {
                      navigator.clipboard.writeText(rtmpUrl);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 1500);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    {copied ? t('Đã copy') : t('Copy')}
                  </Button>
                }
              />
            </Form.Item>
            <Form.Item label={t('Hướng dẫn cấu hình')}>
              <ol style={{ paddingLeft: 20 }}>
                <li>{t('Truy cập quản trị camera IP')}</li>
                <li>{t('Vào quản lý platform')}</li>
                <li>
                  {t('Nhập thông tin RTMP vào cấu hình')}
                  <div style={{ marginTop: 8 }}>
                    <img
                      src={RTMPImage}
                      alt="Hướng dẫn cấu hình RTMP"
                      style={{ maxWidth: 400, marginTop: 8, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    />
                  </div>
                </li>
              </ol>
            </Form.Item>
          </Form>
        </div>
        <div className="btn-update-on-add-gateway">
          <Button
            type="primary"
            onClick={() => {
              form.resetFields();
              setStep(0);
              setSerialInput('');
              setDeviceSerial('');
              setNameInput('');
              setRtmpUrl('');
              setAddress({ note: '' });
              setAlertUpdate({ visible: false, type: null, message: null });
              setIsLoading(false);
              setIsLoad(false);
              setIsBlock(false);
              setRequestId(new Date().getTime());
              handleAddSuccessful();
            }}
          >
            {t('Done')}
          </Button>
        </div>
      </div>
    );
  }
  if (step === 2) {
    return (
      <div className="edit-gateway-component">
        <div className="steps-add-gateways">
          <Steps
            size="small"
            current={step}
            onChange={onChangeStep}
            type="navigation"
            className="site-navigation-steps"
          >
            <Step title={t('Scan')} />
            <Step title={t('Create')} />
            <Step title={t('Update')} />
            <Step title={t('Configuration')} />
          </Steps>
        </div>
        <Form
          form={form}
          {...layout}
          name="form_edit_gateway"
          onFinish={(values) => handleOnUpdate(values)}
        >
          <Form.Item
            name="nameDefault"
            label={t('Name')}
            rules={[
              {
                required: true,
                message: t('Please input the name of gateway!'),
              },
              {
                pattern: regex.isName,
                message: t('Please enter only letters and numbers!'),
              },
              {
                max: 80,
                message: t('Please input up to 80 characters!'),
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item name="lastSerial" label={t('Factory serial')}>
            <Input disabled={true} />
          </Form.Item>
          <Form.Item
            name="location"
            rules={[
              {
                pattern: regex.isName,
                message: t('Please enter only letters and numbers!'),
              },
              {
                max: 200,
                message: t('Please input up to 200 characters!'),
              },
            ]}
            label={t('Location')}
          >
            <LocationSearchLocationIQ
              address={address.note}
              onChange={handleAddressChange}
              onAddressSelect={handleSelect}
              setIsBlock={setIsBlock}
            />
          </Form.Item>
          <Form.Item
            name="tags"
            className="tags-device"
            label={t('Tag')}
            style={{ borer: '1px solid #434343', borderRadius: '2px' }}
          >
            <InputTag numberTag={3} nameAdd="Add tag" />
          </Form.Item>
          <div className="edit-gateway-alert">
            {alertUpdate.visible && (
              <Alert
                {...alertUpdate}
                showIcon
                closable
                onClose={() => setAlertUpdate({ visible: false })}
              />
            )}
          </div>
          <div className="btn-update-on-add-gateway">
            {/* <Button onClick={() => handleAddSuccessful()}>{t('Skip')}</Button> */}
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  // icon={<SaveOutlined />}
                  htmlType="submit"
                  type="primary"
                  loading={isLoad}
                  disabled={
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                >
                  {t('Next')}
                </Button>
              )}
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }

  return (
    <div className="add-box-component">
    <div className="steps-add-gateways">
      <Steps
        size="small"
        current={step}
        onChange={onChangeStep}
        type="navigation"
        className="site-navigation-steps"
      >
        <Step title={t('Scan')} />
        <Step title={t('Create')} />
        <Step title={t('Update')} />
        <Step title={t('Configuration')} />
      </Steps>
    </div>
    {step === 0 && (
      <div className="title-add-box">
        {t('Enter your device serial code, please find it behind device')}
      </div>
    )}
    <div className="main-form-add-box">
      <Form
        form={form}
        {...(step === 0 ? {} : layout)}
        name="horizontal_login"
        layout={step === 0 ? 'inline' : 'horizontal'}
        onFinish={onFinish}
      >
        {step === 0 ? (
          <Form.Item
            name="serial"
            rules={[
              {
                required: true,
                message: t('Please enter the device serial!'),
              },
              {
                len: 16,
                message: t('Factory Serial must be more than 16 characters!'),
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: t('Do not enter special characters, only allow letters and numbers!'),
              },
            ]}
          >
            <Input
              ref={serialRef}
              prefix={<QrcodeOutlined className="site-form-item-icon" />}
              placeholder={t('Factory serial')}
            />
          </Form.Item>
        ) : (
          <>
            <Form.Item name="defaultSerial" label={t('Factory serial')}>
              <Input
                defaultValue={serialInput}
                disabled
                prefix={<QrcodeOutlined className="site-form-item-icon" />}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label={t('Name')}
              rules={[
                {
                  required: true,
                  message: t('Please input the name of gateway!'),
                },
                {
                  pattern: regex.isName,
                  message: t('Please enter only letters and numbers!'),
                },
                {
                  max: 80,
                  message: t('Please input up to 80 characters!'),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </>
        )}
        <div className="btn-update-on-add-gateway">
          <Form.Item shouldUpdate>
            {() => (
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginLeft: '0px' }}
                loading={isLoading}
              >
                {step === 0 ? t('Validate') : t('Create')}
              </Button>
            )}
          </Form.Item>
        </div>
      </Form>
    </div>
  </div>
  )
}

export default RTMPlinkAddCamera
